import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Form from '../../../inputs/Form';
import { getListOptions } from '../../../../services/listService';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { isValidEmail } from '../../../../utils/formatting';

const CompanyProfile = ({ tKey = 'dashboard.settings.profile.', data = null, onFormDataChange }) => {
  const { t } = useTranslation();
  const [fields, setFields] = useState([])
  const [formData, setFormData] = useState({});
  const [isValid, setIsValid] = useState(false);
  const [dropDownOptions, setDropDownOptions] = useState({
    citiesList: [],
  });
  
  const convertProfileSettingsToFormData = (settings) => {
    setFormData({ ...settings,
      city: { label: settings.city ? `${settings.city.npa} ${settings.city.label}` : null, value: settings.city || null },
    });
  };

  useEffect(() => {
    if (data && Object.keys(data).length !== 0) {
      convertProfileSettingsToFormData(data);
    };
  }, [data]);
  
  useEffect(() => {
    const fetchListData = async () => {
      try {
        const citiesList = await getListOptions('city');
        setDropDownOptions({
          citiesList: citiesList.data,
        })
      } catch (error) {
        console.error(error);
        toast.error(error.message);
      };
    };
    fetchListData();
  }, []);

  useEffect(() => {
    if (dropDownOptions.citiesList && dropDownOptions.citiesList.length > 0)
      setFields([
        {
          name: 'name',
          label: t(`${tKey}name.label`),
          placeholder: t(`${tKey}name.placeholder`),
          type: 'text',
          class: 'w-100',
          validate: (value) => {
            if (!value.trim()) return t(`${tKey}errors.name.required`);
            if (value.length < 3) return t(`${tKey}errors.name.min`);
            if (value.length > 50) return t(`${tKey}errors.name.max`);
            return '';
          },
        },
        {
          name: 'address',
          label: t(`${tKey}address.label`),
          placeholder: t(`${tKey}address.placeholder`),
          type: 'text',
          class: 'w-60 pr-2',
          validate: (value) => {
            if (!value.trim()) return t(`${tKey}errors.address.required`);
            if (value.length > 50) return t(`${tKey}errors.address.max`);
            return '';
          },
        },
        {
          name: 'city',
          label: t(`${tKey}city.label`),
          placeholder: t(`${tKey}city.placeholder`),
          type: 'dropdown',
          class: 'w-40 pl-2',
          options: dropDownOptions.citiesList,
          validate: (value) => {
            if (!value) return t(`${tKey}errors.city.required`);
            return '';
          },
          optionFormat: (value) => {
            return `${value.npa} ${value.label} `
          },
        },       
        {
          name: 'phone',
          label: t(`${tKey}phone.label`),
          placeholder: t(`${tKey}phone.placeholder`),
          type: 'phone',
          class: 'w-100',
          validate: (value) => {
            if (!value) return t(`${tKey}errors.phone.required`);
            if (!isValidPhoneNumber(value)) return t(`${tKey}errors.phone.invalid`);
            return '';
          },
        },
        {
          name: 'email',
          label: t(`${tKey}email.label`),
          placeholder: t(`${tKey}email.placeholder`),
          type: 'email',
          class: 'w-100',
          validate: (value) => {
            if (!value) return t(`${tKey}errors.email.required`);
            if (!isValidEmail(value)) return t(`${tKey}errors.email.invalid`);
            return '';
          },
        }
      ])
  }, [dropDownOptions, t, tKey]);

  useEffect(() => {
    onFormDataChange(isValid ? formData : null);
  }, [isValid, formData, onFormDataChange]);

  return (
    <div className='dashboard-content flex gap-2'>
      <div className='w-50 bg-white rounded p-3'>
        <Form formGroupClass='mb-4' fields={fields} currentForm={formData} setFormDetails={setFormData} setIsValid={setIsValid} />
      </div>
    </div>
  );
};

export default CompanyProfile;
